/** Support tickets as /api/production/tickets returns them. */

export type TicketStatus = 'open' | 'in_progress' | 'waiting_on_user' | 'resolved' | 'closed';
export type TicketPriority = 'low' | 'medium' | 'high' | 'urgent';
export type TicketView = 'active' | 'resolved' | 'all';

export const TICKET_STATUSES: TicketStatus[] = [
  'open',
  'in_progress',
  'waiting_on_user',
  'resolved',
  'closed',
];
export const TICKET_PRIORITIES: TicketPriority[] = ['low', 'medium', 'high', 'urgent'];

export interface Ticket {
  id: string;
  ref: string;
  organization: { id: string; name: string };
  raisedBy: { id: string; name: string; email: string } | null;
  reportedFor: { id: string; name: string } | null;
  category: string;
  subject: string;
  description: string | null;
  attachmentUrl: string | null;
  status: TicketStatus;
  priority: TicketPriority;
  createdAt: string;
  resolvedAt: string | null;
  resolvedBy: { id: string; name: string } | null;
  commentCount: number;
  lastActivityAt: string;
  awaitingStaff: boolean;
}

export interface TicketComment {
  id: string;
  author: 'staff' | 'customer';
  authorName: string;
  body: string;
  createdAt: string;
}

export interface TicketDetail extends Ticket {
  comments: TicketComment[];
}

export interface TicketCounts {
  open: number;
  inProgress: number;
  waitingOnUser: number;
  awaitingStaff: number;
  resolvedLast24h: number;
}

export interface TicketListQuery {
  view: TicketView;
  limit: number;
  offset: number;
  priority?: TicketPriority;
  search?: string;
}
